import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { InstantFlowApi } from './api';

const QUERY_KEYS = {
  status: ['instant-flow'] as const,
  orgSetting: (orgId: string) => ['instant-flow', 'org', orgId] as const,
};

export const useInstantFlow = () => {
  return useQuery({
    queryKey: QUERY_KEYS.status,
    queryFn: () => InstantFlowApi.status(),
  });
};

// Every action changes what Meta and the table hold, even one that fails partway (a
// publish whose deprecation fails), so refetch either way.
export const useSyncInstantFlow = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => InstantFlowApi.sync(),
    onSettled: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.status }),
  });
};

export const usePublishInstantFlow = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => InstantFlowApi.publish(),
    onSettled: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.status }),
  });
};

export const useDeprecateInstantFlow = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (flowId: string) => InstantFlowApi.deprecate(flowId),
    onSettled: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.status }),
  });
};

export const useInstantFlowOrgSetting = (orgId: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.orgSetting(orgId),
    queryFn: () => InstantFlowApi.orgSetting(orgId),
    enabled: !!orgId,
  });
};

export const useSetInstantFlowOrgSetting = (orgId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (enabled: boolean) => InstantFlowApi.setOrgSetting(orgId, { enabled }),
    onSettled: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.orgSetting(orgId) }),
  });
};
